export default "<div class=\"responsive responsive-table\">\n  <table class=\"mdc-data-table__ghb\">\n    <ng-content></ng-content>\n  </table>\n</div>"